import React from "react";
import { Link, useSearchParams } from "react-router-dom";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const bookingId = params.get("booking_id");
  return (
    <div data-testid="payment-cancel-page" className="bg-[#F5EFE4] min-h-[80vh]">
      <div className="max-w-[900px] mx-auto px-6 pt-40 pb-24 text-center">
        <p className="overline">Payment cancelled</p>
        <h1 className="font-serif text-5xl mt-4 text-[#1A1815]">No harm done.</h1>
        <p className="text-[#6B665E] mt-4 max-w-lg mx-auto">Your reservation is still saved as a request. You can complete payment at any time from your dashboard.</p>
        <div className="mt-10 flex justify-center gap-4 flex-wrap">
          <Link to="/book" className="luxor-btn-primary" data-testid="cancel-retry">Try again</Link>
          <Link to="/dashboard" className="luxor-btn-outline-dark">Dashboard</Link>
        </div>
        {bookingId && <p className="mt-6 text-xs text-[#6B665E]">Ref: {bookingId}</p>}
      </div>
    </div>
  );
}
